import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-20 bg-primary-600">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
          不确定蘑菇是否有毒？
        </h2>
        <p className="text-primary-100 text-sm md:text-base mb-8 max-w-xl mx-auto">
          不要冒险！使用我们的毒蘑菇测试方法，或参考权威图鉴进行比对。安全永远是第一位。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/identification-methods"
            className="inline-flex items-center gap-2 bg-background-50 hover:bg-background-100 text-primary-700 px-6 py-3 rounded-lg font-medium text-sm transition-colors whitespace-nowrap"
          >
            <i className="ri-shield-check-line"></i>
            学习鉴别方法
          </Link>
          <Link
            to="/category/first-aid"
            className="inline-flex items-center gap-2 bg-primary-500/30 hover:bg-primary-500/40 text-background-50 border border-primary-400/30 px-6 py-3 rounded-lg font-medium text-sm transition-colors whitespace-nowrap"
          >
            <i className="ri-heart-pulse-line"></i>
            中毒急救指南
          </Link>
        </div>
      </div>
    </section>
  );
}